import React from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";
import {
  selectCampaignModalState,
  toggleCampaignModal,
  selectPaymentPlan,
} from "../../../state/ducks/calculation/index";

Modal.setAppElement("#app");

const customStyles = {
  content: {
    position: "absolute", 
    top: "50%", left: "50%",
    right: "auto",
    bottom: "auto",
    outline: "none", 
    padding: "20px", 
    marginRight: "-50%",
    height: "80vh",
    transform: "translate(-50%, -50%)",
    overflowY: "none",
    background: "none",
    border: "none"
  },
};

const PaymentPlan = ({
  isCampaignModalOpen,
  toggleCampaignModal,
  paymentPlan,
}) => {
  return (
    <Modal
      isOpen={isCampaignModalOpen}
      onRequestClose={toggleCampaignModal}
      style={{
        overlay: {
          position: 'fixed',
          inset: "0% 0% 0% 0%",
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.4)'
        },
        content: {
          position: 'fixed',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          top: 0,
          left: 0,
          border: '0px',
          backgroundColor: 'transparent' /* Black w/ opacity */

        }
      }}
      closeTimeoutMS={500}
    >
<div className="t-modalArea" id="id-modal" style={{ display: "block" }}>
  {/* Bu kısım animasyon için Hareket eden kısım. */}
  <div className="t-modalContent" id="id-modalPaymentPlan" style={(window.innerWidth<=900)?{width:"89%"}: {width:"50%"}}>
    <div
      className="t-modal"
      id="id-modalGenel"
      style={{ backgroundColor: "rgb(255, 255, 255)" }}
    >
      <div className="container-fluid">
        {/* Header */}
        <div className="row t-modalHeader">
          <div
            className="col"
            id="id-modalHeader"
            style={{ color: "rgb(153, 153, 153)" }}
          >
            Taksit Detayları
          </div>
          <div className="col-auto t-cursorPointer"  onClick={() => toggleCampaignModal(false)}>
            <i
              className="t-icon-cross"
              id="id-modalHeaderIcon"
              style={{ color: "rgb(153, 153, 153)" }}
            />
          </div>
        </div>
        {/* Body */}
        <div className="row t-modalBody">
          <div
            className="col-12"
            id="id-modalBody"
            style={{ color: "rgb(153, 153, 153)" }}
          >
            <table className="table table-sm t-tablo">
              <thead>
                <tr>
                  <th scope="col">Dönem</th>
                  <th scope="col">İşlem Tarihi</th>
                  <th scope="col">Tutar (₺)</th>
                </tr>
              </thead>
              <tbody>
              {paymentPlan &&
                paymentPlan.taksitler.map((item) => (
                  <tr
                    key={item.donem}
                    style={
                      item.donem === paymentPlan.sonTeslimDonem
                        ? { backgroundColor: "yellow" }
                        : null
                    }
                  >
                    <td>{item.donem}</td>
                    <td>{item.islemTarihiDisplay}</td>
                    <td>
                      <NumberFormat
                        value={item?.tutar}
                        displayType={"text"}
                        thousandSeparator="."
                        decimalSeparator=","
                        prefix={"₺"}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
            </table>
          </div>
        </div>
        {/* footer*/}
        <div className="row t-modalFooter">
          <div
            className="col-12"
            id="id-modalFooter"
            style={{ color: "rgb(153, 153, 153)" }}
          />
        </div>
      </div>
    </div>
  </div>
</div>

    </Modal>
  );
};

const mapStateToProps = (state) => ({
  isCampaignModalOpen: selectCampaignModalState(state),
  paymentPlan: selectPaymentPlan(state),
});

const mapDispatchToProps = (dispatch) => ({
  toggleCampaignModal: () => dispatch(toggleCampaignModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPlan);
